module.exports = __webpack_public_path__ + "static/naytal-logo-0d0fab9137f0cb75a690d3007ff26962.png";